module.exports = __webpack_public_path__ + "static/scale-model-of-hay-tree-in-long-beach-california-443e46879e9037cbdc23543375906461.png";